module.exports = __webpack_public_path__ + "img/39.44a3eec.jpg";